import { Study } from '@/types';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import React, { FC } from 'react';

import { AssaySamplesTable } from './AssaySamplesTable';

interface AssaySamplesPanelGroupProps {
  orgId: string;
  studyId: string;
  study: Study;
}

export const AssaySamplesPanelGroup: FC<AssaySamplesPanelGroupProps> = ({ orgId, study, studyId }) => {
  if (!study.assays || study.assays.length === 0) return null;

  return (
    <Stack fullWidth gap={8} orientation="vertical">
      {study.assays.map((assay, index) => (
        <AssaySamplesTable
          key={`${assay.assay_version ?? 'unknown'}-${index}`}
          assaySummary={assay}
          orgId={orgId}
          studyId={studyId}
          studySummary={study}
        />
      ))}
    </Stack>
  );
};
